(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chaquetas-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ch-faq')) {
    customElements.define(
      'ch-faq',
      class ChFaq extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.items = Array.from(this.querySelectorAll('.ch-faq__item'));
          this.tabs = Array.from(this.querySelectorAll('.ch-faq__tab'));

          this.items.forEach((item) => {
            const btn = item.querySelector('.ch-faq__question');
            btn.addEventListener('click', () => {
              const expanded = btn.getAttribute('aria-expanded') === 'true';
              this.items.forEach((other) => {
                if (other !== item) this.close(other);
              });
              if (expanded) this.close(item);
              else this.open(item);
            });
          });

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.filter(tab));
          });
        }

        open(item) {
          const btn = item.querySelector('.ch-faq__question');
          const answer = item.querySelector('.ch-faq__answer');
          btn.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
          answer.style.visibility = 'visible';
        }

        close(item) {
          const btn = item.querySelector('.ch-faq__question');
          const answer = item.querySelector('.ch-faq__answer');
          btn.setAttribute('aria-expanded', 'false');
          answer.setAttribute('hidden', '');
          answer.style.visibility = 'hidden';
        }

        filter(tab) {
          const cat = tab.dataset.cat;
          this.tabs.forEach((t) => {
            t.classList.remove('ch-faq__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('ch-faq__tab--active');
          tab.setAttribute('aria-selected', 'true');
          this.items.forEach((item) => {
            if (cat === 'all' || item.dataset.cat === cat) {
              item.classList.remove('ch-faq__item--hidden');
            } else {
              item.classList.add('ch-faq__item--hidden');
              this.close(item);
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion-marlop"]) return;
  try {
    
document.addEventListener('change', function (e) {
  if (!e.target.matches || !e.target.matches('.ts-col__select')) return;
  var u = new URL(window.location.href);
  u.searchParams.set('sort_by', e.target.value);
  u.searchParams.delete('page');
  window.location.href = u.toString();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-marlop"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-ts-track]');
    var prev = root.querySelector('[data-ts-prev]');
    var next = root.querySelector('[data-ts-next]');
    if (!track || !prev || !next) return;

    function step() {
      var slide = track.querySelector('.ts-tst__slide');
      if (!slide) return 265;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  function boot() { document.querySelectorAll('.ts-tst').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
